export default {
  model: {
    prop: 'modelValue',
    event: 'change'
  },
  props: {
    proConfig: {
      type: Object,
      default: () => ({})
    },
    proFormData: {
      type: Object,
      default: () => ({})
    },
    proFormDataSource: {
      type: Object,
      default: () => ({})
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentValue: this.modelValue
    };
  },
  computed: {
    currentFormData() {
      return Object.assign({}, this.proFormDataSource, this.proFormData);
    }
  },
  watch: {
    modelValue(val) {
      this.currentValue = val;
    }
  },
  methods: {
    onChange() {
      this.$emit('change', this.currentValue, this.proFormData);
    }
  }
};
